import { FC } from "react";

export const SiderBackIcon: FC = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.3195 0.546499L2.17951 2.6865L0.866172 3.99317C0.312839 4.5465 0.312839 5.4465 0.866172 5.99983L4.3195 9.45317C4.77284 9.9065 5.54617 9.57983 5.54617 8.9465V5.2065V1.05317C5.54617 0.413166 4.77284 0.0931657 4.3195 0.546499Z"
      fill="#007BFB"
    />
  </svg>
);
